import {
  applySchoolYearAction,
  type SchoolYearAction,
  scopeSchoolYear,
  type Workspace,
  type YearRecord,
} from "@classroom/domain";
import type { WorkspaceData } from "./data";

const yearCollections = [
  "classes",
  "students",
  "dailyRecords",
  "homeworkAssignments",
  "homeworkRecords",
  "calendarEvents",
  "homeroomRecords",
  "attendanceRecords",
  "homeroomHomeworkRecords",
  "studentRoutineItems",
  "seatingCharts",
  "quizzes",
  "quizSessions",
  "quizResponses",
] as const;
type YearData = Pick<WorkspaceData, (typeof yearCollections)[number]> & { workspace?: Workspace };
export function schoolYearRows(data: YearData): YearRecord[] {
  return yearCollections.flatMap((collection) =>
    data[collection].map((item) => ({ collection, recordId: item.id, data: item as unknown as YearRecord["data"] })),
  );
}
function fromRows<T extends YearData>(data: T, rows: YearRecord[]): T {
  return {
    ...data,
    ...Object.fromEntries(
      yearCollections.map((collection) => [
        collection,
        rows.filter((row) => row.collection === collection).map((row) => row.data),
      ]),
    ),
  };
}
export function schoolYearView<T extends YearData>(data: T, id: string): T {
  if (!data.workspace) return data;
  return fromRows(data, scopeSchoolYear(data.workspace, schoolYearRows(data), id));
}
export function changeSchoolYear<T extends YearData & { workspace: Workspace }>(data: T, action: SchoolYearAction): T {
  const next = applySchoolYearAction(data.workspace, schoolYearRows(data), action);
  return fromRows({ ...data, workspace: next.workspace }, next.records);
}
